/**
 * "Kopen met iDEAL" button under the add-to-cart button: adds the selected variant and quantity of the product form to the
 * cart and goes straight to the checkout, where the customer picks iDEAL. Shopify has no iDEAL express button, so this
 * stands in for it. Without JavaScript the button is hidden (the normal add-to-cart button keeps working).
 * No dependencies.
 */
class PtBuyNow extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    this.button = this.querySelector('[data-buy-now]');
    this.button?.addEventListener('click', () => this.#buy(), { signal: this.#abort.signal });
    this.hidden = false;
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  async #buy() {
    const form = this.closest('form');
    if (!form || !this.button || this.button.disabled) return;
    const root = window.Shopify?.routes?.root ?? '/';
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        signal: this.#abort?.signal,
      });
      if (!response.ok) throw new Error(`cart ${response.status}`);
      location.assign(`${root}checkout`);
    } catch {
      // the cart page shows what is (not) in the cart, so the customer is never stuck on a dead button
      location.assign(`${root}cart`);
    }
  }
}

if (!customElements.get('pt-buy-now')) customElements.define('pt-buy-now', PtBuyNow);
